module.exports = "/_next/static/images/Matthew_Stewart-51e05d1e92ef197fdb54bc434e6295a8.webp";